import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ICategory } from 'src/app/interfaces/category';

import { ApiService } from '../../../app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { PageEvent } from '@angular/material/paginator';
import { IResponseBody } from 'src/app/interfaces/response-body';

@Injectable()
export class CategoryApiService {
  constructor(
    private Api: ApiService,
    private dialog: MatDialog,
    protected commonFunctionService: CommonFunctionService
  ) {}

  public getAllCategories(role: string, filter?: {}) {
    let endpoint = `${role}/categories`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.get(endpoint, url).then(
      (Categories) => Categories,
      (error) => this.Api.handleError(error)
    );
  }

  public list(role: string, itemId: number, localOffer: boolean = false) {
    return new Promise((resolve, reject) => {
      let endpoint = `${role}/listings/prod_id/${itemId}/category`;

      if (localOffer) {
        endpoint = `${role}/categories/offer/${itemId}?localOffer=true`;
      }

      const url = this.commonFunctionService.findApiUrl(role);

      setTimeout(() =>
        this.Api.get(endpoint, url).then(
          (result: ICategory[]) => resolve(result),
          (error) => reject(error)
        )
      );
    });
  }

  public save(
    role: string,
    productId: number,
    Category: ICategory,
    localOffer: Boolean = false
  ) {
    const categoryId = Category.id || null;
    let successMessage = Category.title + ' added.';
    let endpoint = `${role}/category`;

    if (productId) {
      endpoint = localOffer
        ? `${role}/category/${Category.id}/offer/${productId}`
        : `${role}/listings/${productId}/category/${Category.id}`;
      successMessage = 'Added to ' + Category.title;
    } else if (categoryId) {
      endpoint = `${role}/category/${categoryId}`;
      successMessage = Category.title + ' updated.';
    }

    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.put(endpoint, Category, url).then(
      (result) => {
        this.Api.handleSuccess(successMessage);
        return result;
      },
      (error) => this.Api.handleError(error)
    );
  }

  public delete(
    role: string,
    productId: number,
    Category: ICategory,
    localOffer: boolean = false
  ) {
    let endpoint = `${role}/listings/${productId}/category/${Category.id}`;
    const url = this.commonFunctionService.findApiUrl(role);

    if (localOffer) {
      endpoint = `${role}/category/${Category.id}/offer/${productId}`;
    }

    return this.Api.delete(endpoint, url).then(
      () => this.Api.handleSuccess(`${Category.title} removed.`),
      (error) => this.Api.handleError(error)
    );
  }

  public deleteCategory(role: string, id: number) {
    let endpoint = `${role}/category/${id}`;
    const url = this.commonFunctionService.findApiUrl(role);

    return this.Api.delete(endpoint, url)
      .then((ResponseBody: IResponseBody) => ResponseBody)
      .catch((error) => this.Api.handleError(error));
  }

  public listWithPageEvent(role: string, filter?: {}, PageEvent?: PageEvent) {
    let endpoint = `${role}/categories`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.getWithPageEventFilter(endpoint, PageEvent, filter, url)
      .then((ResponseBody: IResponseBody) => ResponseBody)
      .catch((error) => this.Api.handleError(error));
  }
}
